<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Student To Room" @close="close()" />
      <v-card-text v-if="selectedClassRoom">
        <v-row>
          <v-col cols="12" sm="12">
            <div>
              Class:
              <span class="font-weight-bold text-capitalize">{{
                selectedClassRoom.Class.name
              }}</span>
            </div>
            <div>
              Room Name:
              <span class="font-weight-bold text-capitalize">{{
                selectedClassRoom.name
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="10">
            <v-autocomplete dense autofocus hide-details :items="Students" clearable item-value="id"
            item-text="fullName"
              v-model="selectedStudent" return-object label="Select Student" outlined>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="text--primary text-capitalize" v-text="item.fullName">
                  </v-list-item-title>

                  <v-list-item-subtitle class="caption" v-if="!item.ClassRoomStudents.length">
                    <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                      Not Assign To Any Class
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="caption" v-if="item.ClassStudents.length"
                    v-text="item.ClassStudents[0].Class.name">
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action-text
                  v-if="item.ClassRoomStudents.length > 0 && item.ClassRoomStudents[0].ClassRoom.name">
                  <v-list-item-title class="text--primary text-capitalize"
                    v-text="item.ClassRoomStudents[0].ClassRoom.name">
                  </v-list-item-title>
                </v-list-item-action-text>
                <!-- <span>{{ item.fullName }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-google-classroom</v-icon>
                  </v-avatar>
                  <span>{{ item.classCount }}</span>
                </v-chip>
              </template> -->
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn @click="submit" :disabled="!selectedStudent" color="success">Add</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-list class="list-350">
          <template v-for="(row, index) in StudentList">
            <v-list-item :key="index">
              <v-list-item-avatar>
                <v-btn icon>
                  <v-icon color="red" @click="deleteRow(row)">delete</v-icon>
                </v-btn>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize" v-if="row.Student">{{
                  row.Student.fullName
                }}</v-list-item-title>
                <v-list-item-title class="text-capitalize" v-else>
                  <v-chip color="red">Student Not Exist</v-chip>

                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <div>
          <span class="font-weight-bold text-capitalize">Total Students: </span>
          <span class="font-weight-medium text-capitalize">{{StudentList.length}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <!-- <v-btn color="green lighten-1" :loading="loading" dark @click="submit()">save</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classRoomService from "@/modules/ClassRoom/service.js";
import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    selectedClassRoom: {
      type: Object,
    },
  },
  name: "Assign-Class-to-student",
  data() {
    return {
      Students: [],
      selectedStudent: null,
      StudentList: [],
      loading: false,
      dialog: false,
      fee: 0,
      discount: 0,
      sponsor: 0,
      parentPay: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.sponsor;
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    // selectedStudent(val) {
    //   console.log("val in selected ", val);
    //   if (val) {
    //     this.fee = this.selectedClassRoom.defaultFee;
    //     this.parentPay = this.selectedClassRoom.defaultFee;
    //   }
    // },
    dialog(val) {
      if (val) {
        this.getStudent();
        this.getAssStudentList()
      }
    },
  },
  methods: {
    getAssStudentList() {
      return classRoomService
        .getAssignStudentList({ ClassRoomId: this.selectedClassRoom.id })
        .then((response) => {
          console.log("response", response);
          this.StudentList = response.data;
          return response;
        });
    },
    deleteRow(row) {
      console.log("row", row);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          classRoomService
            .removeStudent(row.id)
            .then((response) => {
              if (response.data) {
                const studentId = (element) => element.id === row.id;

                let i = this.StudentList.findIndex(studentId);
                this.StudentList.splice(i, 1);
                this.$swal(
                  "Remove!",
                  "Student has been remove from this teacher.",
                  "success"
                );
                // this.getList();
              }
            });
        }
      });
    },
    async submit() {
      let obj = {
        ClassRoomId: this.selectedClassRoom.id,
        StudentId: this.selectedStudent.id,
      };
      classRoomService
        .assignStudent(obj)
        .then((result) => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Student was assist to class",
            });

          this.StudentList.push(result.data);
          // this.empty();
          // this.$emit("submit");
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });

      this.selectedStudent = null;
    },
    getStudent() {
      return studentService.getAll({ClassId: this.selectedClassRoom.ClassId}).then((response) => {
        this.Students = response.data;
        // this.Students.map(student => {
        //   if (student.firstName == 'Ahmad') {
        //     console.log('name: ', student)
        //   }

        // })
        console.log("response Students", this.Students);

        return response;
      });
    },
    close() {
      this.empty();
      // this.$emit("close");
      this.$emit("submit");
    },
    empty() {
      this.selectedStudent = null;
      this.fee = 0;
      this.discount = 0;
      this.sponsor = 0;
      this.parentPay = 0;
    },
  },
};
</script>

<style scoped></style>
